import { render, staticRenderFns } from "./Identifier.vue?vue&type=template&id=67484592&scoped=true&"
import script from "./Identifier.vue?vue&type=script&lang=js&"
export * from "./Identifier.vue?vue&type=script&lang=js&"
import style0 from "./Identifier.vue?vue&type=style&index=0&id=67484592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67484592",
  null
  
)

export default component.exports